import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlMarkResponse extends IIsiDtoPresentationLogicResponse  {
    getMarkUnmarkResult?: IIsiDtoPlMarkGetMarkUnmarkResult;
}
export interface IIsiDtoPlMarkGetMarkUnmarkResult extends IIsiDataTransferObject  {
    message?: string;
    hasError?: boolean;
    updatedTotal?: number;
    selectedTotal?: number;
}
export class IsiDtoPlMarkGetMarkUnmarkResult extends IsiDataTransferObject implements IIsiDtoPlMarkGetMarkUnmarkResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoPlMarkGetMarkUnmarkResult, Isilog.IsiComponent.IsiDataTransferObject";
    message?: string;
    hasError?: boolean;
    updatedTotal?: number;
    selectedTotal?: number;

    constructor(data?: IIsiDtoPlMarkGetMarkUnmarkResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.hasError = _data["hasError"] !== undefined ? _data["hasError"] : false;
            this.updatedTotal = _data["updatedTotal"] !== undefined ? _data["updatedTotal"] : 0;
            this.selectedTotal = _data["selectedTotal"] !== undefined ? _data["selectedTotal"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoPlMarkGetMarkUnmarkResult): IsiDtoPlMarkGetMarkUnmarkResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMarkGetMarkUnmarkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["hasError"] = this.hasError !== undefined ? this.hasError : false;
        data["updatedTotal"] = this.updatedTotal !== undefined ? this.updatedTotal : 0;
        data["selectedTotal"] = this.selectedTotal !== undefined ? this.selectedTotal : 0;
        return data;
    }
}
export class IsiDtoPlMarkResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlMarkResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoPlMarkResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getMarkUnmarkResult?: IsiDtoPlMarkGetMarkUnmarkResult;

    constructor(data?: IIsiDtoPlMarkResponse) {
        super(data);
        if (data) {
            this.getMarkUnmarkResult = data.getMarkUnmarkResult && !(<any>data.getMarkUnmarkResult).toJSON ? new IsiDtoPlMarkGetMarkUnmarkResult(data.getMarkUnmarkResult) : <IsiDtoPlMarkGetMarkUnmarkResult>this.getMarkUnmarkResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getMarkUnmarkResult = _data["getMarkUnmarkResult"] ? IsiDtoPlMarkGetMarkUnmarkResult.fromJS(_data["getMarkUnmarkResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMarkResponse): IsiDtoPlMarkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMarkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getMarkUnmarkResult"] = this.getMarkUnmarkResult != null ? (<any>this.getMarkUnmarkResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlMarkRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlMarkResponse;
    records?: IIsiDtoPlMarkRecords;
    table?: string;
    clauseWhere?: IIsiDtoPlMarkClauseWhere[];
    contextId?: string;
    isgrid?: boolean;
    itemClick?: string;
    mark?: boolean;
}
export interface IIsiDtoPlMarkRecords extends IIsiDataTransferObject  {
    selected?: IIsiDtoSelectedRecordSet;
}
export interface IIsiDtoSelectedRecordSet extends IIsiDataTransferObject  {
    records?: IIsiDtoSelectedRecord[];
    isAllSelected?: boolean;
}
export interface IIsiDtoSelectedRecord extends IIsiDataTransferObject  {
    fields?: IIsiDtoSelectedFieldValue[];
}
export interface IIsiDtoSelectedFieldValue extends IIsiDataTransferObject  {
    value?: string;
    key?: string;
}
export class IsiDtoSelectedFieldValue extends IsiDataTransferObject implements IIsiDtoSelectedFieldValue {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedFieldValue, Isilog.IsiComponent.IsiDataTransferObject";
    value?: string;
    key?: string;

    constructor(data?: IIsiDtoSelectedFieldValue) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoSelectedFieldValue): IsiDtoSelectedFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
export class IsiDtoSelectedRecord extends IsiDataTransferObject implements IIsiDtoSelectedRecord {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedRecord, Isilog.IsiComponent.IsiDataTransferObject";
    fields?: IsiDtoSelectedFieldValue[];

    constructor(data?: IIsiDtoSelectedRecord) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fields = _data["fields"] !== undefined ? _data["fields"] : [];
        }
    }

    static fromJS(data?: IIsiDtoSelectedRecord): IsiDtoSelectedRecord {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["fields"] = this.fields !== undefined ? this.fields : [];
        return data;
    }
}
export class IsiDtoSelectedRecordSet extends IsiDataTransferObject implements IIsiDtoSelectedRecordSet {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedRecordSet, Isilog.IsiComponent.IsiDataTransferObject";
    records?: IsiDtoSelectedRecord[];
    isAllSelected?: boolean;

    constructor(data?: IIsiDtoSelectedRecordSet) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.records = _data["records"] !== undefined ? _data["records"] : [];
            this.isAllSelected = _data["isAllSelected"] !== undefined ? _data["isAllSelected"] : false;
        }
    }

    static fromJS(data?: IIsiDtoSelectedRecordSet): IsiDtoSelectedRecordSet {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedRecordSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["records"] = this.records !== undefined ? this.records : [];
        data["isAllSelected"] = this.isAllSelected !== undefined ? this.isAllSelected : false;
        return data;
    }
}
export class IsiDtoPlMarkRecords extends IsiDataTransferObject implements IIsiDtoPlMarkRecords {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoPlMarkRecords, Isilog.IsiComponent.IsiDataTransferObject";
    selected?: IsiDtoSelectedRecordSet;

    constructor(data?: IIsiDtoPlMarkRecords) {
        super(data);
        if (data) {
            this.selected = data.selected && !(<any>data.selected).toJSON ? new IsiDtoSelectedRecordSet(data.selected) : <IsiDtoSelectedRecordSet>this.selected;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selected = _data["selected"] ? IsiDtoSelectedRecordSet.fromJS(_data["selected"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMarkRecords): IsiDtoPlMarkRecords {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMarkRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["selected"] = this.selected != null ? (<any>this.selected).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlMarkClauseWhere extends IIsiDataTransferObject  {
    value?: string;
    table?: string;
    colonne?: string;
}
export class IsiDtoPlMarkClauseWhere extends IsiDataTransferObject implements IIsiDtoPlMarkClauseWhere {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoPlMarkClauseWhere, Isilog.IsiComponent.IsiDataTransferObject";
    value?: string;
    table?: string;
    colonne?: string;

    constructor(data?: IIsiDtoPlMarkClauseWhere) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.colonne = _data["colonne"] !== undefined ? _data["colonne"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlMarkClauseWhere): IsiDtoPlMarkClauseWhere {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMarkClauseWhere();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["colonne"] = this.colonne !== undefined ? this.colonne : <any>null;
        return data;
    }
}
export class IsiDtoPlMarkRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlMarkRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoPlMarkRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlMarkResponse;
    records?: IsiDtoPlMarkRecords;
    table?: string;
    clauseWhere?: IsiDtoPlMarkClauseWhere[];
    contextId?: string;
    isgrid?: boolean;
    itemClick?: string;
    mark?: boolean;

    constructor(data?: IIsiDtoPlMarkRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlMarkResponse(data.response) : <IsiDtoPlMarkResponse>this.response;
            this.records = data.records && !(<any>data.records).toJSON ? new IsiDtoPlMarkRecords(data.records) : <IsiDtoPlMarkRecords>this.records;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlMarkResponse.fromJS(_data["response"]) : <any>null;
            this.records = _data["records"] ? IsiDtoPlMarkRecords.fromJS(_data["records"]) : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.clauseWhere = _data["clauseWhere"] !== undefined ? _data["clauseWhere"] : [];
            this.contextId = _data["contextId"] !== undefined ? _data["contextId"] : <any>null;
            this.isgrid = _data["isgrid"] !== undefined ? _data["isgrid"] : false;
            this.itemClick = _data["itemClick"] !== undefined ? _data["itemClick"] : <any>null;
            this.mark = _data["mark"] !== undefined ? _data["mark"] : false;
        }
    }

    static fromJS(data?: IIsiDtoPlMarkRequest): IsiDtoPlMarkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlMarkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["records"] = this.records != null ? (<any>this.records).toJSON() : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["clauseWhere"] = this.clauseWhere !== undefined ? this.clauseWhere : [];
        data["contextId"] = this.contextId !== undefined ? this.contextId : <any>null;
        data["isgrid"] = this.isgrid !== undefined ? this.isgrid : false;
        data["itemClick"] = this.itemClick !== undefined ? this.itemClick : <any>null;
        data["mark"] = this.mark !== undefined ? this.mark : false;
        return data;
    }
}
